import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useMemo } from 'react';
import { FormattedMessage as Translation } from 'react-intl';
import cx from 'classnames';
import useValuationResults from "../useValuationResults";
var css = {
  "bookAppointment": "oalp-1tIXD",
  "bookAppointment__heading": "oalp-1AelE",
  "bookAppointment__subtext": "oalp-58FFJ",
  "bookAppointment__subPos": "oalp-1ys16",
  "priceContent": "oalp-uGLU0",
  "priceContent__desktop": "oalp-2A7BU",
  "priceContent__truePrice": "oalp-1zE7i",
  "priceContent__priceRange": "oalp-3bCyg",
  "priceContent__conditions": "oalp-2t2Ro",
  "priceContent__aboutConditions": "oalp-RRFTU",
  "bookAppointment__subfooter": "oalp-1rU4g",
  "bookAppointment__btnContainer": "oalp-SBRMI",
  "ctaBtn": "oalp-2Aq9F",
  "bookAppointment__terms": "oalp-2gE2S",
  "bookAppointment__benefits": "oalp-1x65c",
  "bookAppointment__benefitRow": "oalp-2Upp_",
  "bookAppointment__header": "oalp-3LQoK",
  "bookAppointment__headerText": "oalp-3N17w",
  "bookAppointment__subHeader": "oalp-2d5DU",
  "bookAppointment__subHeaderLeft": "oalp-rd2rI",
  "bookAppointment__subHeaderRight": "oalp-23zZC",
  "bookAppointment__subHeader__title": "oalp-XWseo",
  "bookAppointment__subHeader__subTitle": "oalp-1h6DZ",
  "bookAppointment__logo": "oalp-1wiEl",
  "bookAppointment__headerImage": "oalp-1w-s1",
  "bookAppointment__editBtn": "oalp-Z5B72",
  "bookAppointmentV2": "oalp-2GDzg",
  "bookAppointmentV2__headerWrapper": "oalp-21y1f",
  "bookAppointmentV2__graph": "oalp-3o32E",
  "bookAppointmentV2__selected": "oalp-3ZTLR",
  "bookAppointmentV2__imageLoop": "oalp-1eNIP",
  "bookAppointmentV2__conditionText": "oalp-2yz90",
  "bookAppointmentV2__imageText": "oalp-1G0WV",
  "bookAppointmentV2__carProps": "oalp-25tVf",
  "bookAppointmentV2__carProps__condition": "oalp-1VeOL",
  "bookAppointmentV2__carProps__condition_textHead": "oalp-1ivhg",
  "bookAppointmentV2__carProps__condition_textVal": "oalp-3pZEU",
  "bookAppointmentV2__carProps__features": "oalp-3-XVq",
  "bookAppointmentV2__carProps__features_prop": "oalp-8x7_8",
  "bookAppointmentV2__carProps__features_prop_icon": "oalp-2jFaO",
  "bookAppointmentV2__carProps__features_prop_text": "oalp-QGcoX",
  "priceContent__arrow": "oalp-2XWbi",
  "bookAppointmentV2__subHeader": "oalp-3CijZ",
  "bookAppointmentV2__subHeaderLeft": "oalp-1dn1N",
  "bookAppointmentV2__subHeaderLeft_mileage": "oalp-3gRrT",
  "bookAppointmentV2__subHeader__title": "oalp-1zD2j",
  "bookAppointmentV2__subHeader__subTitle": "oalp-W5WYm",
  "bookAppointmentV2__subHeaderRight": "oalp-1Zqfe",
  "bookAppointmentV2__editIconWithText": "oalp-Ik_ey",
  "bookAppointmentV2__editText": "oalp-QnJr1",
  "bookAppointmentV2__editBtn": "oalp-35Y_w",
  "bookAppointmentV2__ctaCont": "oalp-cPazQ",
  "bookAppointmentV2__ctaGroup": "oalp-1Vule",
  "bookAppointmentV2__ctaGroup_ctaBtn": "oalp-3F_w-",
  "bookAppointmentV2__q2bCarDetailsWrapper": "oalp-khfGO",
  "bookAppointmentV2__q2bPrefixSuffix": "oalp-3W_On",
  "bookAppointmentV2__qtbEditAlign": "oalp-25jJV",
  "bookAppointmentV2__revamp": "oalp-AkA6E",
  "headerWrapper": "oalp-3ag62",
  "carDetails__text": "oalp-rdKQs",
  "carDetails__text--bold": "oalp-1vSCU",
  "carDetails__text--light": "oalp-3h8yJ",
  "editBtnWrapper": "oalp-1Im-N",
  "editBtn": "oalp-259K1",
  "editBtnTR": "oalp-3Ifuy",
  "detailsContentWrapper": "oalp-2TEWu",
  "conditionsList": "oalp-fbIh2",
  "conditionsList__item": "oalp-2hBCT",
  "conditionsList__item--active": "oalp-3WzZP",
  "conditionsList__item__text": "oalp-2Y4o2",
  "contentWrapper": "oalp-1vkHa",
  "contentWrapperWithPrice": "oalp-2W0RH",
  "withPadding--small": "oalp-3r3Mu",
  "withPadding--large": "oalp-3NfFe",
  "withBorderTop": "oalp-2a3Fz",
  "withBgColor": "oalp-1OYbM",
  "contentWrapper__arrow": "oalp-xJRnY",
  "contentWrapperWithPrice__arrow": "oalp-1NcbD",
  "content": "oalp-1xWwR",
  "priceWrapper": "oalp-2hVb8",
  "price": "oalp-37cPk",
  "price--mobile": "oalp-9wrCW",
  "priceTR": "oalp-2aX1v",
  "priceText": "oalp-1EROH",
  "condition-details": "oalp-2ylgm",
  "condition-details__title": "oalp-Duo4U",
  "detailsList": "oalp-3N3LP",
  "detailsList__item": "oalp-XqONa"
};
import ImageWrapper from "../../../Components/ImageWrapper/ImageWrapper";
import { Icon } from 'panamera-react-ui';
import { DESKTOP, MOBILE } from "../../../Constants/platform";
import { DependencyManager } from "../../../DependencyManager";
import { useConfig } from "../../../ComponentDependency/useConfig";
import { SITECODES } from "../../../Constants/siteCodes";
export var BookAnAppointmentViewRevamp = function BookAnAppointmentViewRevamp(_ref) {
  var _ref$data = _ref.data,
    _ref$data$widgetImage = _ref$data.widgetImagesSection,
    widgetImagesSection = _ref$data$widgetImage === void 0 ? [] : _ref$data$widgetImage,
    termsText = _ref$data.termsText,
    _ref$data$pricePrefix = _ref$data.pricePrefixImage,
    pricePrefixImage = _ref$data$pricePrefix === void 0 ? {
      url: '',
      alt: ''
    } : _ref$data$pricePrefix,
    metadata = _ref.metadata,
    editIconClick = _ref.editIconClick,
    track = _ref.track;
  var _ref2 = metadata || {},
    widgetStyle = _ref2.style,
    staticStrings = _ref2.staticStrings,
    showEditIcon = _ref2.showEditIcon;
  var _useValuationResults = useValuationResults(track),
    conditionLabels = _useValuationResults.conditionLabels,
    displayName = _useValuationResults.displayName,
    selectedIndex = _useValuationResults.selectedIndex,
    selectedConditionText = _useValuationResults.selectedConditionText,
    minPrice = _useValuationResults.minPrice,
    maxPrice = _useValuationResults.maxPrice,
    predictedPrice = _useValuationResults.predictedPrice,
    displayYear = _useValuationResults.displayYear,
    displayMileage = _useValuationResults.displayMileage,
    predictionList = _useValuationResults.predictionList,
    onSelectingCondition = _useValuationResults.onSelectingCondition,
    getArrowStyleRevamp = _useValuationResults.getArrowStyleRevamp;
  var config = useConfig();
  var isTR = useMemo(function () {
    return (config === null || config === void 0 ? void 0 : config.get('siteCode')) === SITECODES.OLXTR;
  }, [config]);
  var PanameraConstants = DependencyManager.getDependency('constants');
  var isMobile = PanameraConstants.platform === MOBILE;
  var isDesktop = PanameraConstants.platform === DESKTOP;
  var descriptionTitle = staticStrings === null || staticStrings === void 0 ? void 0 : staticStrings.conditionText.replace('{condition_value}', selectedConditionText);
  if (selectedIndex < 0) {
    return null;
  }
  var renderPriceSection = function renderPriceSection(onlyPriceSection) {
    var price = minPrice === maxPrice ? predictedPrice : "".concat(minPrice, " - ").concat(maxPrice);
    return /*#__PURE__*/React.createElement("div", {
      className: cx(css.contentWrapperWithPrice, _defineProperty({}, css.withBorderTop, onlyPriceSection && isDesktop), _defineProperty({}, css.withBgColor, onlyPriceSection && isMobile))
    }, /*#__PURE__*/React.createElement("div", {
      className: css.priceWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: cx(css.price, _defineProperty({}, css.priceTR, isTR), _defineProperty({}, css['price--mobile'], isMobile))
    }, /*#__PURE__*/React.createElement(ImageWrapper, {
      image: pricePrefixImage
    }), /*#__PURE__*/React.createElement("span", {
      className: cx(_defineProperty({}, css.priceText, isMobile))
    }, price))));
  };
  var renderContent = function renderContent() {
    var _cx7;
    var _a, _b, _c;
    if (conditionLabels.length < 2) {
      return renderPriceSection(true);
    }
    return /*#__PURE__*/React.createElement("div", {
      className: css.detailsContentWrapper
    }, /*#__PURE__*/React.createElement("ul", {
      className: css.conditionsList
    }, conditionLabels.map(function (condition, idx) {
      return /*#__PURE__*/React.createElement("li", {
        key: "car_condition_".concat(condition, "_").concat(idx),
        "data-aut-id": "condition-item",
        onClick: function onClick() {
          return onSelectingCondition({
            value: idx.toString()
          });
        },
        className: cx(css.conditionsList__item, _defineProperty({}, css['conditionsList__item--active'], selectedIndex === idx))
      }, /*#__PURE__*/React.createElement("span", {
        className: css.conditionsList__item__text
      }, condition));
    })), /*#__PURE__*/React.createElement("div", {
      className: cx(css.contentWrapper, (_cx7 = {}, _defineProperty(_cx7, css['withPadding--small'], isMobile), _defineProperty(_cx7, css['withPadding--large'], isDesktop), _cx7))
    }, /*#__PURE__*/React.createElement("div", {
      className: css.contentWrapper__arrow,
      style: getArrowStyleRevamp()
    }), /*#__PURE__*/React.createElement("div", {
      className: css.content
    }, renderPriceSection(), /*#__PURE__*/React.createElement("div", {
      className: css.graph
    }, /*#__PURE__*/React.createElement(ImageWrapper, {
      image: (_a = widgetImagesSection === null || widgetImagesSection === void 0 ? void 0 : widgetImagesSection[selectedIndex]) === null || _a === void 0 ? void 0 : _a.on.image
    })), /*#__PURE__*/React.createElement("div", {
      className: css['condition-details']
    }, /*#__PURE__*/React.createElement("h3", {
      className: css['condition-details__title']
    }, descriptionTitle), /*#__PURE__*/React.createElement("ol", {
      className: css.detailsList
    }, (_c = (_b = predictionList[selectedIndex]) === null || _b === void 0 ? void 0 : _b.staticDescription) === null || _c === void 0 ? void 0 : _c.map(function (description, idx) {
      var key = "".concat(description, "-").concat(idx);
      return /*#__PURE__*/React.createElement("li", {
        key: key,
        className: css.detailsList__item
      }, description);
    }))))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: css.bookAppointmentV2__revamp,
    style: widgetStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: css.headerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css.carDetails
  }, /*#__PURE__*/React.createElement("p", {
    className: cx(css.carDetails__text, css['carDetails__text--bold'])
  }, displayName, " ", displayYear), /*#__PURE__*/React.createElement("p", {
    className: cx(css.carDetails__text, css['carDetails__text--light'])
  }, displayMileage)), /*#__PURE__*/React.createElement("div", {
    className: css.editBtnWrapper
  }, showEditIcon ? /*#__PURE__*/React.createElement("button", {
    className: css.bookAppointment__editBtn,
    onClick: editIconClick,
    "data-aut-id": "edit_btn"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "editSquare",
    size: 24,
    color: "primaryBase"
  })) : /*#__PURE__*/React.createElement("button", {
    className: cx(css.editBtn, _defineProperty({}, css.editBtnTR, isTR)),
    onClick: editIconClick,
    "data-aut-id": "edit_btn"
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "editAd"
  })))), renderContent(), termsText && /*#__PURE__*/React.createElement("p", {
    style: termsText.style
  }, termsText.text));
};
export default BookAnAppointmentViewRevamp;